module.exports = __webpack_public_path__ + "static/media/wave.0de24011.png";